import React, { useEffect, useState } from "react";
import "./VendorListingPage1.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SearchServices } from "../../../context/Slice/ServiceManagementSlice";
import { jwtDecode } from "jwt-decode";
import DynamicFilterBar from "./DynamicFilterBar";
import { ShowAllCategories } from "../../../context/Slice/VendorManagementSlice";

const BackEnd_URL = process.env.REACT_APP_BASE_URL;

const VendorListingPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const categoryName =
    location.state?.categoryName || params.get("category") || "";
  const locationName =
    location.state?.locationName || params.get("location") || "";

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [vendors, setVendors] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [filterSelections, setFilterSelections] = useState({});
  const [filteredVendorsData, setFilteredVendorData] = useState([]);

  const searchResults = useSelector((state) => state.ServiceManagementR.Data);
  const testcategorie = useSelector((state) => state.VendorManagementR.AllCat);
  console.log(searchResults);

  useEffect(() => {
    dispatch(ShowAllCategories())
      .unwrap()
      .then((result) => {
        console.log("Categories from API:", result?.ShowAllCategorie); // ✅ Shows correct data
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, [dispatch]);

  useEffect(() => {
    const fetchVendors = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await dispatch(
          SearchServices({
            CategoryName: categoryName,
            City: locationName, // Sending selected location
          })
        );

        if (Array.isArray(response.payload) && response.payload.length > 0) {
          setVendors(response.payload);
          setFilteredVendorData(response.payload);
        } else {
          setVendors([]);
        }
      } catch (err) {
        setError("Failed to fetch vendors. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (searchResults.length > 0) {
      setVendors(searchResults);
      setFilteredVendorData(searchResults);
    }
    // If searchResults is empty and categoryName/locationName is available, fetch data
    else if ((categoryName || locationName) && searchResults.length === 0) {
      fetchVendors();
    }
  }, [categoryName, locationName, searchResults, dispatch]);

  const handleViewDetails = (vendor) => {
    // Get the token from local storage
    const token = localStorage.getItem("token");

    if (token) {
      try {
        // Decode the JWT token
        const decodedToken = jwtDecode(token);

        // Extract the role from the decoded token
        const role = decodedToken.role;

        // Save the role to localStorage
        localStorage.setItem("role", role);
        console.log("Role extracted from token:", role);

        if (vendor.ServiceCategory_ID) {
          localStorage.setItem("ServiceCategory_ID", vendor.ServiceCategory_ID);
          console.log("Stored ServiceCategory_ID:", vendor.ServiceCategory_ID);
        }

        // Check if the role is valid
        const allowedRoles = ["USER", "ADMIN", "VENDOR", "CO-ORDINATOR"];
        if (allowedRoles.includes(role)) {
          navigate(`/vendor-details/${vendor.Vendor_ID}`);
        } else {
          setShowLoginPopup(true); // Show login popup if role is not valid
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setShowLoginPopup(true); // Show login popup if token is invalid
      }
    } else {
      setShowLoginPopup(true); // Show login popup if no token
    }
  };
  const handleLoginRedirect = () => {
    setShowLoginPopup(false); // Close the popup
    navigate("/login"); // Redirect to the login page
  };

  const parseImageUrl = (imageData) => {
    try {
      if (!imageData) {
        console.warn("Image data is null or undefined. Returning default image.");
        return "assets/dummyProfile.jpg"; // Fallback to default image
      }
  
      const parsedData = JSON.parse(imageData); // Parse the JSON string
      if (!Array.isArray(parsedData) || parsedData.length === 0 || !parsedData[0]?.path) {
        console.warn("Invalid image data structure. Returning default image.");
        return "assets/dummyProfile.jpg";
      }
  
      let imagePath = parsedData[0].path;
  
      // Normalize slashes (useful for Windows paths)
      imagePath = imagePath.replace(/\\/g, "/"); 
  
      // Remove unwanted base paths
      imagePath = imagePath
        .replace("/home/ubuntu/new/CEP_BackEnd/", "")
        .replace("/home/CEP_BackEnd/", "")
        .replace(/^\/+/, ""); // Ensure no leading slashes remain
  
      // Construct the final URL
      const imageUrl = `${BackEnd_URL}/BannerUploads/${imagePath.split("/").pop()}`;
  
      console.log("Parsed Image URL:", imageUrl);
      return imageUrl;
    } catch (err) {
      console.warn("Failed to parse image data. Returning default image.", err);
      return "assets/dummyProfile.jpg"; // Fallback to a default image
    }
  };
  
  const filterData = (selections) => {
    if (
      Object.keys(selections).length === 0 ||
      Object.values(selections).every((val) => val.length === 0)
    ) {
      // Show all data if no filters are applied
      setFilteredVendorData(filteredVendorsData);
      return;
    }

    let filteredData = [...vendors]; // Start with the original vendor list

    Object.keys(selections).forEach((filterKey) => {
      if (selections[filterKey].length > 0) {
        console.log(
          `Applying filter for key: ${filterKey} with values:`,
          selections[filterKey]
        );

        // Handle filtering for DynamicData
        if (filterKey !== "SpecialBadges") {
          filteredData = filteredData.filter((vendor) => {
            const parseAndLogVendor = (vendorData) => {
              if (!vendorData) {
                console.error(
                  "No vendor data available for this vendor:",
                  vendor
                );
                return null;
              }
              console.log("Vendor DynamicData:", vendorData);
              return JSON.parse(vendorData); // Parse dynamic data
            };

            const VendorDynamicData = parseAndLogVendor(vendor.DynamicData);

            if (VendorDynamicData && VendorDynamicData[filterKey]) {
              const vendorValue = VendorDynamicData[filterKey];
              console.log(
                `Checking vendor: ${
                  vendor.Name || vendor.id
                }, Key: ${filterKey}, Value:`,
                vendorValue
              );

              if (Array.isArray(vendorValue)) {
                const match = selections[filterKey].some((selected) =>
                  vendorValue.includes(selected)
                );
                console.log(
                  `Array Match for vendor: ${vendor.Name || vendor.id}, Match:`,
                  match
                );
                return match;
              } else {
                const match = selections[filterKey].includes(vendorValue);
                console.log(
                  `Direct Match for vendor: ${
                    vendor.Name || vendor.id
                  }, Match:`,
                  match
                );
                return match;
              }
            }

            console.log(`No match for vendor: ${vendor.Name || vendor.id}`);
            return false; // Exclude unmatched vendors
          });
        } else {
          // Handle filtering for SpecialBadges (separate field from DynamicData)
          filteredData = filteredData.filter((vendor) => {
            console.log(
              `Checking SpecialBadges for vendor: ${vendor.Name || vendor.id}`
            );

            if (vendor.SpecialBadges) {
              // Parse the SpecialBadges field (if it's a stringified array)
              let badgesArray = [];
              try {
                badgesArray = JSON.parse(vendor.SpecialBadges);
              } catch (error) {
                console.error(
                  "Error parsing SpecialBadges for vendor:",
                  vendor
                );
              }

              // Now filter based on the parsed array
              const match = selections[filterKey].some((selectedBadge) =>
                badgesArray.includes(selectedBadge)
              );
              console.log(
                `SpecialBadge Match for vendor: ${
                  vendor.Name || vendor.id
                }, Match:`,
                match
              );
              return match;
            }

            console.log(
              `No match for SpecialBadges for vendor: ${
                vendor.Name || vendor.id
              }`
            );
            return false; // Exclude unmatched vendors
          });
        }

        console.log(`Filtered Data after key: ${filterKey}`, filteredData);
      }
    });

    if (filteredData.length === 0) {
      console.log("No vendors match the current filters.");
      setFilteredVendorData([]); // If no matches, show empty data
      return;
    }

    console.log("Final Filtered Data:", filteredData);
    setFilteredVendorData(filteredData);
  };

  const handleFilterChange = (fieldName, selectedValue, isSingleSelection) => {
    setFilterSelections((prevSelections) => {
      const updatedSelections = {
        ...prevSelections,
        [fieldName]: isSingleSelection ? [selectedValue] : selectedValue,
      };

      if (
        Object.values(updatedSelections).every(
          (selection) => selection.length === 0
        )
      ) {
        setFilteredVendorData(filteredVendorsData); // Reset to original vendors
      } else {
        filterData(updatedSelections); // Apply filters
      }

      return updatedSelections;
    });
  };

  // const filteredCategories = testcategorie.filter(
  //   (category) =>
  //     category.status === true && category.CategorieName === categoryName
  // );
  // console.log("Filtered Categories:", filteredCategories[0] );

  const renderNavbar = () => {
    const currentCategory = testcategorie.find(
      (category) => category.CategorieName === categoryName
    );

    // console.log("Current Category:", currentCategory);

    if (!currentCategory || !currentCategory.CategorieFields) {
      return null; // No category found or fields missing
    }

    // Parse CategorieFields from string to object
    const parsedCategorieFields = JSON.parse(currentCategory.CategorieFields);

    // console.log("Parsed CategorieFields:", parsedCategorieFields);
    return (
      <div className="navbar" style={{ marginBottom: "10rem" }}>
        <DynamicFilterBar
          categoryFields={parsedCategorieFields}
          filterSelections={filterSelections}
          handleFilterChange={handleFilterChange}
          setFilterSelections={setFilterSelections} // Pass setFilterSelections
          setFilteredVendorData={setFilteredVendorData} // Pass setFilteredVendorData
          filteredVendors={vendors} // Pass original unfiltered data
          categoryName={categoryName}
        />
      </div>
    );
  };

  return (
    <div id="vendor-listing">
      <div
        className="row"
        style={{
          width: "100vw",
          position: "fixed",
          top: "8rem",
          zIndex: "10",
          marginBottom: "100px",
        }}
      >
        {renderNavbar()}
      </div>{" "}
      <div className="vendor-listing-container">
        <h2 className="vendor-listing-title">
          {categoryName || locationName || "Vendors"} in{" "}
          {locationName || "All Locations"}
        </h2>

        {loading ? (
          <p className="text-center mt-5">Loading vendors...</p>
        ) : error ? (
          <p className="text-center text-danger mt-5">{error}</p>
        ) : filteredVendorsData.length > 0 ? (
          <div className="row">
            {filteredVendorsData
              .filter((vendor) => vendor.status === "approved")
              .map((vendor, index) => (
                <div className="col-md-4 mb-4" key={index}>
                  <div className="card vendor-card">
                    <img
                      src={
                        vendor.BannerImage
                          ? parseImageUrl(vendor.BannerImage)
                          : "/assets/dummyProfile.jpg"
                      }
                      className="card-img-top vendor-card-img"
                      alt={vendor.ServiceName}
                    />
                    <div className="vendor-card-body">
                      <h5 className="vendor-name">{vendor.Vendor.firstName}</h5>
                      {/* <p className="vendor-description">
                    {vendor.ServiceDescription || "Click to explore!"}
                  </p> */}
                      <div className="vendor-card-info">
                        <span className="vendor-location">
                          <strong>Service Locations:</strong>{" "}
                          {(() => {
                            try {
                              return vendor && vendor.ServiceLocations
                                ? Array.isArray(
                                    JSON.parse(vendor.ServiceLocations)
                                  )
                                  ? JSON.parse(vendor.ServiceLocations).join(
                                      ", "
                                    )
                                  : "Unknown Location"
                                : "Unknown Location";
                            } catch (error) {
                              return "Unknown Location";
                            }
                          })()}
                        </span>

                   
                        <span className="vendor-budget">
  <strong>Budget:</strong>{" "}
  {vendor.ServiceName === "VENUE" || vendor.ServiceName === "WEDDING CATERERS"
    ? JSON.parse(vendor.DynamicData || "{}")["BudgetSlab"] || "N/A"
    : vendor.TotalBudget || "N/A"}
</span>

                      </div>
                      <button
                        className="btn btn-primary vendor-btn"
                        onClick={() => handleViewDetails(vendor)}
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            {showLoginPopup && (
              <div className="popup-overlay">
                <div className="popup-content">
                  <p>To know the vendor details, please do log in first.</p>
                  <button
                    className="btn btn-primary"
                    onClick={handleLoginRedirect}
                  >
                    Login
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center mt-5">
            <img
              src="/assets/no-vendor-found.svg"
              alt="No Vendors"
              style={{ width: "200px" }}
            />
            <p className="mt-3">
              No vendors available for this category and location.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorListingPage;
